import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import PageSubTitle from '../Components/Layout/PageSubTitle';
import BlogPost from '../Components/Sections/BlogPost';

import AboutImg from '../images/about-us-img.png';
import AboutImg1 from '../images/about-img-1.jpg';
import AboutImg2 from '../images/about-img-2.jpg';
import SectionTitle from '../Components/ui/SectionTitle';
import ImgHoverEffect from '../Components/ui/ImgHoverEffect';
import { motion } from 'framer-motion';

export default function AboutUs() {
    return (
        <>
            <PageSubTitle pagename="About Us" />
            <motion.section initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className='section'>
                <Container>
                    <Row>
                        <Col className="text-center mb-5">
                            <motion.h1 initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className="mb-1">Welcome to <span className='text-danger'>Reshto</span></motion.h1>
                            <motion.p initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className="text-muted">Redefining food delivery, Reshto connects you to your favorite meals with ease and speed.</motion.p>
                        </Col>
                    </Row>
                    <Row className="align-items-center">
                        <Col lg={6}>
                            <ImgHoverEffect className="d-inline-block" intensity={20} scale={1.05}>
                                <Image src={AboutImg} alt="Mission" className="img-fluid about-img-size w-100 rounded-4 png-img-shadow-xs img-hover" />
                            </ImgHoverEffect>
                        </Col>
                        <Col lg={6}>
                            <motion.div initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='ms-lg-5 mt-lg-0 mt-4'>
                                <motion.h1 initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className="fw-semibold mb-4"><span className='text-danger fw-semibold'>Our Mission</span> Connecting You with the Flavors You Love, Anytime, Anywhere.</motion.h1>
                                <motion.p initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='text-muted mb-4 fs-18'>At Reshto, we aim to make food delivery effortless and enjoyable. With quality meals and rapid delivery, we bring dining excellence to your doorstep.</motion.p>
                                <div className="d-flex align-items-center mb-2">
                                    <div className="flex-shrink-0">
                                        <i className="ri-checkbox-circle-line text-success fs-24"></i>
                                    </div>
                                    <div className="flex-grow-1 fs-18 text-muted ms-2">
                                        Delivering fresh meals that cater to every lifestyle and taste.
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <div className="flex-shrink-0">
                                        <i className="ri-checkbox-circle-line text-success fs-24"></i>
                                    </div>
                                    <div className="flex-grow-1 fs-18 text-muted ms-2">
                                        Ensuring fast delivery without compromising on quality.
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0">
                                        <i className="ri-checkbox-circle-line text-success fs-24"></i>
                                    </div>
                                    <div className="flex-grow-1 fs-18 text-muted ms-2">
                                        Partnering with trusted restaurants for an exceptional dining experience.
                                    </div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </motion.section>

            <motion.section initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} className='section'>
                <Container>
                <Row className='justify-content-center'>
                        <Col md={6} className='section-title text-center mb-5'>
                            <SectionTitle title="Why Choose Reshto?"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} lg={4}>
                            <Card className='text-center  mb-xl-0'>
                                <Card.Body>
                                    <div className='avatar avatar-lg bg-soft-primary text-primary border border-soft-primary rounded-3 mx-auto'>
                                        <i className="ri-truck-line"></i>
                                    </div>
                                    <h5 className="mt-4 mb-1">Swift & Reliable Delivery</h5>
                                    <p className='text-muted mb-0'>Your favorite meals delivered hot and fresh, right when you need them.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={4}>
                            <Card className='text-center mb-xl-0'>
                                <Card.Body>
                                    <div className='avatar avatar-lg bg-soft-success text-success border border-soft-success rounded-3 mx-auto'>
                                        <i className="ri-time-line"></i>
                                    </div>
                                    <h5 className="mt-4 mb-1">Customized for You</h5>
                                    <p className='text-muted mb-0'>Flexible dining solutions tailored to your taste, schedule, and lifestyle.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <Card className='text-center mb-xl-0'>
                                <Card.Body>
                                    <div className='avatar avatar-lg bg-soft-warning text-warning border border-soft-warning rounded-3 mx-auto'>
                                        <i className="ri-discount-percent-line"></i>
                                    </div>
                                    <h5 className="mt-4 mb-1">Exceptional Value</h5>
                                    <p className='text-muted mb-0'>Save big with exclusive deals while enjoying premium-quality meals.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
            <motion.section initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}}  className='section'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={6} className='section-title text-center mb-5'>
                            <SectionTitle title="Discover Reshto"/>
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-5 pb-5">
                        <Col lg={6}>
                            <motion.div initial={{opacity: 0, x: -20}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}} className='img-effect'>
                                <Image src={AboutImg1} alt="Our Restaurant" className="img-fluid rounded-4 png-img-shadow-sm img-hover" />
                            </motion.div>
                        </Col>
                        <Col lg={6}>
                            <motion.div initial={{opacity: 0, x: 20}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}} className='ms-lg-5 mt-lg-0 mt-5'>
                                <div className='avatar avatar-lg bg-soft-danger text-danger border border-soft-danger rounded-3 mb-3'>
                                    <i className="ri-restaurant-line"></i>
                                </div>
                                <h1 className="mb-3 fw-semibold">Our Restaurant</h1>
                                <p className="text-muted">
                                    At Reshto, we believe dining is not just about food but also about creating moments.
                                    Our restaurant provides a cozy, welcoming ambiance that enhances your dining experience,
                                    making every meal special. From casual family dinners to celebrations, Reshto is the perfect spot.
                                </p>
                                <p className="text-muted">
                                    We take pride in serving dishes made from the finest ingredients. With our diverse menu
                                    of traditional and modern cuisines, we aim to satisfy every palate. Join us to enjoy
                                    delightful meals prepared with care and precision.
                                </p>
                                <ul className="list-unstyled mb-0">
                                    <li className="d-flex align-items-center mb-2">
                                        <i className="ri-checkbox-circle-line text-success fs-20 me-2"></i>
                                        A warm, inviting atmosphere for every occasion.
                                    </li>
                                    <li className="d-flex align-items-center">
                                        <i className="ri-checkbox-circle-line text-success fs-20 me-2"></i>
                                        Delicious meals crafted from the freshest ingredients.
                                    </li>
                                </ul>
                            </motion.div>
                        </Col>
                    </Row>

                    <Row className="align-items-center mb-5">
                        <Col lg={6}>
                            <motion.div initial={{opacity: 0, x: -20}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}} className='me-lg-5'>
                                <div className='avatar avatar-lg bg-soft-success text-success border border-soft-success rounded-3 mb-3'>
                                    <i className="ri-restaurant-2-line"></i>
                                </div>
                                <h1 className="mb-3 fw-semibold">Our Services</h1>
                                <p className="text-muted">
                                    At Reshto, we focus on making your dining experience seamless and enjoyable. Whether you
                                    dine in, take out, or order delivery, we are committed to providing you with exceptional service.
                                    Our focus on quality and efficiency ensures your satisfaction every time.
                                </p>
                                <p className="text-muted">
                                    Our services are designed with your convenience in mind. From speedy delivery to personalized
                                    customer care, Reshto goes the extra mile to bring you the best. We’re here to make your meals
                                    memorable and stress-free.
                                </p>
                                <ul className="list-unstyled mb-0">
                                    <li className="d-flex align-items-center mb-2">
                                        <i className="ri-truck-line text-primary fs-20 me-3"></i>
                                        Fast and reliable food delivery to your doorstep.
                                    </li>
                                    <li className="d-flex align-items-center">
                                        <i className="ri-star-line text-primary fs-20 me-3"></i>
                                        Personalized services to meet your unique needs.
                                    </li>
                                </ul>
                            </motion.div>
                        </Col>
                        <Col lg={6}>
                            <motion.div initial={{opacity: 0, x: 20}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}} className='img-effect'>
                                <Image src={AboutImg2} alt="Our Restaurant" className="img-fluid rounded-4 png-img-shadow-sm img-hover" />
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </motion.section>

            <BlogPost />
        </>
    )
}
